import { DispatchCard } from 'src/entities/dispatch';

/**
 * この回転で積みに行く地点の数（積込タグ）。
 * サンプル (route-planner: pages/MapPage.tsx:1554) と同じ数え方。
 *
 * 同一性は座標優先（地点集約の既定の規則）。座標が欠けている行は名称で切る。
 * 座標だけで判定すると、座標欠損のカードが全部 1 件に潰れる
 * （countDeliveryDestinations と同じ理由）。
 *
 * Why 積地カードが無くても 1: 降地があるなら、どこかから積んで来ている。
 * 0 と出すと「積み込みが無い便」に見える。
 */
export function countPickups(cards: DispatchCard[]): number {
  const seen = new Set<string>();
  let hasDelivery = false;

  cards.forEach((card) => {
    if (card.type === 'delivery') { hasDelivery = true; return; }
    if (card.type !== 'loading') return;
    const geo = card.geo;
    seen.add(geo ? `geo:${geo.lat},${geo.lng}` : `name:${card.locationName}`);
  });

  if (seen.size > 0) return seen.size;
  return hasDelivery ? 1 : 0;
}
